import { Checkbox } from 'antd'
import { ConversationalAI } from '@forwardflow/components/Campaign/Assistants/ConversationalAI'
import { useAddAssistantsModalStore } from '@forwardflow/store/modal/AddAssistantsModal'
import { useState } from 'react'
import { usePrompts } from '@forwardflow/hooks/customHooks/usePrompts'
import useSetupProgress from '@forwardflow/hooks/customHooks/onboarding/useSetupProgress'

export interface AssistantCardProps {
   assistant: {
      voice_id: string
      avatar: string
      name: string
      description: string
   }
   onSelect: (assistant: any, isSelected: boolean) => void
   isSelected?: boolean
}

export const AssistantCard: React.FC<AssistantCardProps> = ({
   assistant,
   onSelect,
   isSelected = false,
}) => {
   const [isConversationActive, setIsConversationActive] = useState(false)

   const { isAddAssistantsModalOpen } = useAddAssistantsModalStore()
   const { conversationalAiPrompt } = usePrompts()
   const setupProgress = useSetupProgress()

   const handleCheckboxChange = (checked: boolean) => {
      onSelect(assistant, checked)
   }

   const handleCardClick = (e: React.MouseEvent) => {
      if ((e.target as HTMLElement).closest('.conversational-ai-area')) {
         return
      }
      handleCheckboxChange(!isSelected)
   }

   const dynamicVariables = {
      organization_name: setupProgress.data?.businessDetails?.legalBusinessName || 'Organization',
      name: assistant.name || 'Assistant',
   }

   return (
      <div
         className="relative flex items-center gap-6 px-6 py-4 transition-all cursor-pointer bg-primary/10 hover:bg-primary/20 group"
         onClick={handleCardClick}
      >
         <Checkbox
            name={assistant?.voice_id}
            checked={isSelected}
            onChange={(e) => handleCheckboxChange(e.target.checked)}
            onClick={(e) => e.stopPropagation()}
         />

         <div className="w-[68px] h-[68px] shrink-0 rounded bg-primary/50 flex justify-center items-end relative group overflow-hidden conversational-ai-area">
            <img
               loading="lazy"
               src={assistant?.avatar}
               alt="assistant"
               className="max-h-14"
            />

            <div className={`absolute inset-0 items-center justify-center bg-primary/80 ${isConversationActive ? 'flex' : 'hidden group-hover:flex'
               }`}>
               {isAddAssistantsModalOpen && (
                  <ConversationalAI
                     voiceId={assistant.voice_id}
                     prompt={conversationalAiPrompt?.prompt ?? ''}
                     dynamicVariables={dynamicVariables}
                     onConversationStateChange={setIsConversationActive}
                  />
               )}
            </div>
         </div>

         <div className="conversational-ai-area">
            <div className="flex items-center mb-3 gap-x-2">
               <p className="font-medium">{assistant?.name}</p>
            </div>
            <p className="text-white/70 text-[12px] font-medium line-clamp-2">
               {assistant?.description}
            </p>
         </div>
      </div>
   )
}